/**
 * Created by denis on 26/12/19
 */

const GameModes = function () {
    if (!cleverapps.config.debugMode) {
        return;
    }

    this.noControls = false;
    this.noToolbar = false;
    this.noTools = false;
    this.noSidebar = false;
    this.noUpMenu = false;
    this.noBg = false;
    this.noBoosters = false;
    this.noNotifications = false;
    this.noMute = false;
    this.noGamePause = false;

    // debugging modes
    this.showAvoidRects = false;
    this.showPersonSilhouette = false;
    this.stopOnFogSave = false;
    this.prerollEnabled = false;
    this.alternativeHard = false;
    this.noInviteFriends = false;
    this.noPlacementsThrottle = false;
    this.fastPlacementsThrottle = false;

    if (cleverapps.config.type === "merge") {
        Object.assign(this, {
            skipThirdElement: false,
            skipSpecialOffer: false,
            skipBuildingStage: false,
            skipOpenChestWindow: false,
            skipQuests: false,
            skipTutorials: false,
            skipUnitStories: false,
            skipRestoreLandmarks: false,
            automerge: false,
            axemerge: false,
            hideGuideAndProgress: false,
            hideFruitParticlesAnimation: false,
            hideUnitPointAnimation: false,
            fastSpawnPrizes: false,
            upgradeInTwoTurns: false,
            customAnimationDidMerged: false,
            unitsPulsingDisabled: false,
            easyChop: false,
            dontCollectWands: false,
            lightUpOnHoveredUnit: false,
            hideGeneratorGuideButton: false,
            silentInfoView: false,
            silentCustomers: false,
            silentCenterHint: false,
            fogBlockerDisabled: false,
            hideTankProgress: false,
            initFruitWithoutPrizes: false,
            initMineableWithPrizes: false,
            multipleHeroes: false,
            clans: false,
            captureToolActions: false,
            skipFlyToUnitsLibrary: false,
            skipUnitCreatePrize: false,
            skipExpPrize: false,
            muteCupsSound: false,
            scrollByFinger: false,
            showTriggerLock: false,
            stopLazyLoading: false
        });
    } else if (cleverapps.config.type === "merge2") {
        Object.assign(this, {
            merge2BalanceStats: false
        });
    } else if (cleverapps.config.type === "match3") {
        Object.assign(this, {
            silentGoals: false,
            multiColorCellDisabled: false,
            heroesDisabled: false,
            putInPoolDisabled: false,
            newRules: false
        });
    } else if (cleverapps.config.type === "blocks") {
        Object.assign(this, {
            hideGoals: false,
            hideHighScore: false,
            alwaysNoMemorable: false,
            showHint: false,
            piecesAlwaysEnabled: false,
            hideSingleMoveHint: false,
            hideExplodeHint: false,
            hidePieces: false,
            weightedFigures: false
        });
    } else if (cleverapps.config.type === "tile3") {
        Object.assign(this, {
            threeOpenCards: false,
            skipProlongation: false,
            replaceTiles: false
        });
    } else if (cleverapps.config.type === "board") {
        Object.assign(this, {
            noKeypad: false,
            noCurrent: false,
            noCookieJar: false,
            hideKeypadControls: false
        });
    }
};

GameModes.prototype.load = function () {
    if (!cleverapps.config.debugMode) {
        return;
    }

    const data = cleverapps.dataLoader.load(DataLoader.TYPES.GAME_MODES) || {};
    Object.assign(this, data);
};

GameModes.prototype.save = function () {
    const data = { ...this };
    cleverapps.dataLoader.save(DataLoader.TYPES.GAME_MODES, data);
};

GameModes.prototype.toggle = function (mode) {
    this[mode] = !this[mode];
    this.save();
};

GameModes.prototype.listModes = function () {
    return Object.keys(this);
};
